import { ChangeEventHandler, ClipboardEventHandler, forwardRef, KeyboardEventHandler } from 'react';

export interface TranslationTextAreaType {
	id: string | undefined;
	value: string | number | readonly string[] | undefined;
	placeholder: string;
	onChange: ChangeEventHandler<HTMLTextAreaElement>;
	onKeyDown?: KeyboardEventHandler<HTMLTextAreaElement>;
	onPaste?: ClipboardEventHandler<HTMLTextAreaElement>;
	className: string | undefined;
	rtl: boolean;
	isReadOnly: boolean;
	tabIndex?: number;
}

const TranslationTextArea = forwardRef<HTMLTextAreaElement, TranslationTextAreaType>(
	({ rtl, id, value, className, placeholder, onChange, onKeyDown, isReadOnly, onPaste, tabIndex }, ref) => {
		return (
			<textarea
				dir={rtl ? 'rtl' : 'ltr'}
				ref={ref}
				required
				id={id}
				value={value}
				placeholder={placeholder}
				className={className}
				readOnly={isReadOnly}
				title={''}
				onChange={onChange}
				onPaste={onPaste}
				onKeyDown={onKeyDown}
				tabIndex={tabIndex}
			/>
		);
	});

export default TranslationTextArea;
